import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message
} from '../../../web.common';
import { LayoutContext } from '../../layout/siteLayout';
import PageTop from '../../layout/PageTop';
import withApi from '../../higherOrderComponents/withApi';
import {
  DisplayBoolean,
  DisplayDate,
  DisplayGuid,
  DisplayStatus,
  DisplayType,
  DisplayPaymentMethod
} from '../../items';
import { DetailsRightBar, NoLink, Divider } from '../DetailsRightBar';
import { paymentMethodStatus } from '../../../enums/paymentMethodStatus';
import { paymentMethodType } from '../../../enums/paymentMethodType';

class PaymentMethodUndefinedInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethodData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { paymentMethodId } } } = this.props;
    const { api: { paymentMethods: { getPaymentMethodUndefined } } } = this.props;

    try {
      const paymentMethodData = await getPaymentMethodUndefined(paymentMethodId);
      this.setState({ paymentMethodData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const { match: { params: { paymentMethodId } } } = this.props;
    const { paymentMethodData, errorMessage } = this.state;

    let mappedData = null;

    if (paymentMethodData) {
      const {
        Id,
        CreatedAtCet,
        UserId,
        DisplayName = '',
        Token = '',
        IsDefault = false,
        Type,
        Status
      } = paymentMethodData;

      mappedData = {
        Id: <DisplayGuid>{Id}</DisplayGuid>,
        'Created At (CET)': <DisplayDate>{CreatedAtCet}</DisplayDate>,
        Status: <DisplayStatus mapping={paymentMethodStatus}>{Status}</DisplayStatus>,
        'User Id': <DisplayGuid baseAnchor='/user'>{UserId}</DisplayGuid>,
        DisplayName,
        Token,
        Type: <DisplayType mapping={paymentMethodType}>{Type}</DisplayType>,
        IsDefault: <DisplayBoolean>{IsDefault}</DisplayBoolean>,
        'Payment Method': <DisplayPaymentMethod>{paymentMethodData}</DisplayPaymentMethod>
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Payment method details'
                documentDescription='Payment method details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Payment Method
              </h2>
              <h5 className='main-page-subheader'>{paymentMethodId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              <NoLink>None</NoLink>
              <Divider>Actions</Divider>
              <NoLink>None</NoLink>
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const PaymentMethodUndefined = withRouter(withApi(connect(({ user }) =>
  ({ isLoggedIn: !!user }), {})(PaymentMethodUndefinedInternal)));

PaymentMethodUndefined.requiresLogin = true;
PaymentMethodUndefined.propTypes = { isLoggedIn: PropTypes.bool };

export default PaymentMethodUndefined;
